import { Country } from '@/entities/Country';
import { State } from '@/entities/State';
import { apiClient } from './api-client';
import URI from 'urijs';

/**
 * Service to retrieve countries and their states.
 */
export class CountryService {
    private get baseUrl(): URI {
        return new URI('/api/countries');
    }

    public async getAllCountries(): Promise<Country[]> {
        const res = await apiClient.get<Country[]>(this.baseUrl.toString());
        return res.data;
    }

    public async getStatesOfCountry(countryId: number): Promise<State[]> {
        const res = await apiClient.get<State[]>(
            this.baseUrl
                .segmentCoded(countryId.toString(10))
                .segmentCoded('states')
                .toString()
        );
        return res.data;
    }
}
